<template>
<div class="vue-youtube-iframe">
    <youtube
        v-if="hasYoutubeVideoId"
        :video-id="youtubeVideoId"
        ref="youtube"
        :fit-parent="true"
    ></youtube>
</div>
</template>

<script>
import VueYoutube from 'vue-youtube'

export default {
    name: "YoutubeIframe",

    components: {
        'vue-youtube': VueYoutube
    },

    props: {
        url: {
            type: String,
            required: true,
        }
    },

    computed: {
        youtubeVideoId() {
            let url = this.url.replace(/(>|<)/gi, '').split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);

            if (! lodash.isNil(url[2])) {
                return url[2].split(/[^0-9a-z_\-]/i)[0];
            }

            return '';
        },

        hasYoutubeVideoId() {
            return ! lodash.isEmpty(this.youtubeVideoId);
        },

        player() {
            return this.$refs.youtube.player
        }
    }
}
</script>